import { useEffect } from "react";

const ROBOTS_CONTENT = "noindex,nofollow";

const upsertMeta = (name) => {
  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    meta.setAttribute("data-legal-noindex", "true");
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", ROBOTS_CONTENT);
};

const removeOwnedMeta = () => {
  document
    .querySelectorAll('meta[data-legal-noindex="true"]')
    .forEach((meta) => meta.remove());
};

const useNoIndex = () => {
  useEffect(() => {
    upsertMeta("robots");
    upsertMeta("googlebot");

    return removeOwnedMeta;
  }, []);
};

export default useNoIndex;
